import { selectorFamily } from "recoil";

import { checkIsErrorShowInRideTopInfo, unique } from "../../helpers";
import { RydeUiUnit } from "../../models";
import {
  apiDataFetchingErrorsAtom,
  errorsCrudContentAtomFamily,
} from "../atoms";

export const serverErrorsCombinedSF = selectorFamily<string[], RydeUiUnit>({
  key: "serverErrorsCombinedSF",
  get:
    entity =>
    ({ get }) => {
      const crudErrors = get(errorsCrudContentAtomFamily(entity));
      const apiErrors = get(apiDataFetchingErrorsAtom);
      const combinedErrors = [
        ...(crudErrors || []),
        ...(apiErrors || []),
      ].filter(x => x);
      return unique(combinedErrors);
    },
});

export const serverErrorsRideTopInfo = selectorFamily<string[], RydeUiUnit>({
  key: "serverErrorsRideTopInfo",
  get:
    entity =>
    ({ get }) => {
      const crudErrors = get(serverErrorsCombinedSF(entity));

      return crudErrors.filter(error => checkIsErrorShowInRideTopInfo(error));
    },
});
